var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"private-hybrid dark-section\" role=\"private-hybrid\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 text-center\"\u003E\u003Ch2\u003EPrivate and Hybrid Cloud-Ready\u003C\u002Fh2\u003E\u003Cp class=\"center-paragraph\"\u003EAuth0’s architecture makes it possible to deploy the cloud service as an appliance when a public cloud-based solution is not acceptable due to compliance or legal requirements\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/financial-services/view/private-hybrid.pug
// module id = 1271
// module chunks = 0